const messages = {
  title: "Informazioni su BS Plus",
  description: "About page description",
};

export default {
  messages,
};
